import { LatLng } from '@porterin/booking-flow/src/order-review/domain/entities/LatLng';
import { Waypoint } from '@porterin/booking-flow/src/order-review/domain/entities/Waypoint';
import { MapLocationAddressCmp } from '@porterin/component-library/src/location-accuracy/components/MapLocationAddressCmp';
import { MapPinCmp } from '@porterin/component-library/src/location-accuracy/components/MapPinCmp';
import { useLocation } from '@porterin/component-library/src/location-accuracy/contexts/LocationContext';
import { handleMapDragEnd } from '@porterin/component-library/src/location-accuracy/utils/LocationAccuracyHelpers';
import { AppConfig } from '@porterin/component-library/src/ts-utils/analytics/fetch-config/AppConfig';
import { getAppConfig } from '@porterin/component-library/src/ts-utils/analytics/fetch-config/FetchConfig';
import { GoogleMap } from '@react-google-maps/api';
import React, { useCallback, useEffect, useRef, useState } from 'react';

const Config: AppConfig = getAppConfig();

const containerStyle = {
  width: '100vw',
  height: '100vh',
};

const mapOptions: google.maps.MapOptions = {
  disableDefaultUI: true,
  clickableIcons: false,
  streetViewControl: false,
  fullscreenControl: false,
  keyboardShortcuts: false,
  zoomControl: false,
  gestureHandling: 'greedy',
};

export interface MapLocationSelectionProps {
  waypoint: Waypoint;
}

export const MapLocationSelectionCmp: React.FC = () => {
  const { state, selectLocation } = useLocation();

  const [center, setCenter] = useState<LatLng>({
    lat: state.address?.location.lat || 12.9715987,
    lng: state.address?.location.lng || 77.594566,
  });
  const [isDragging, setIsDragging] = useState(false);
  const mapRef = useRef<google.maps.Map | null>(null);
  const debounceRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const onLoad = useCallback((map: google.maps.Map) => {
    mapRef.current = map;
  }, []);

  const onDragStart = () => {
    setIsDragging(true);
  };

  const onDragEnd = useCallback(() => {
    handleMapDragEnd({
      mapRef,
      debounceRef,
      setIsDragging,
      setCenter,
      selectLocation,
    });
  }, [selectLocation]);

  useEffect(() => {
    return () => {
      if (debounceRef.current) {
        clearTimeout(debounceRef.current);
      }
    };
  }, []);

  return (
    <div className="relative w-full h-full">
      <GoogleMap
        mapContainerStyle={containerStyle}
        center={center}
        zoom={18}
        options={mapOptions}
        onLoad={onLoad}
        onDragStart={onDragStart}
        onDragEnd={onDragEnd}
      />
      <MapPinCmp />
      <MapLocationAddressCmp is_dragging={isDragging} set_center={setCenter} />
    </div>
  );
};
